import React, { useEffect, useState } from 'react';
import Chatbotmessager from "react-simple-chatbot";

// const steps = [
//     {
//       id: 'welcome',
//       message: 'Welcome to Triokzz 👋 I am Ghanashyam. How can I help you today?',
//       trigger: 'askName'
//     },
  
//     {
//       id: 'askName',
//       message: 'May I know your name?',
//       trigger: 'getName'
//     },
  
//     {
//       id: 'getName',
//       user: true,
//       trigger: 'mainMenu'
//     },
  
//     {
//       id: 'mainMenu',
//       message: 'Hi {previousValue} 😊 Please choose your query:',
//       trigger: 'faqOptions'
//     },
  
//     {
//       id: 'faqOptions',
//       options: [
//         { value: 'shipping', label: '🚚 Shipping Info', trigger: 'shippingReply' },
//         { value: 'payment', label: '💳 Payment Methods', trigger: 'paymentReply' },
//         { value: 'return', label: '🔁 Return Policy', trigger: 'returnReply' },
//         { value: 'order', label: '📦 Track Order', trigger: 'orderReply' },
//         { value: 'agent', label: '💬 Talk to Human (WhatsApp)', trigger: 'whatsapp' }
//       ]
//     },
  
//     {
//       id: 'shippingReply',
//       message: 'We deliver orders within 3–7 business days across India 🚚',
//       trigger: 'askMore'
//     },
  
//     {
//       id: 'paymentReply',
//       message: 'We accept UPI, Debit/Credit Cards, Net Banking and Cash on Delivery 💳',
//       trigger: 'askMore'
//     },
  
//     {
//       id: 'returnReply',
//       message: 'You can return products within 7 days of delivery. Refund will be processed in 3 working days 🔁',
//       trigger: 'askMore'
//     },
  
//     {
//       id: 'orderReply',
//       message: 'Please keep your Order ID ready. Our support team will help you track it 📦',
//       trigger: 'whatsapp'
//     },
  
//     {
//       id: 'askMore',
//       message: 'Do you need more help?',
//       trigger: 'moreOptions'
//     },
  
//     {
//       id: 'moreOptions',
//       options: [
//         { value: 'yes', label: 'Yes 👍', trigger: 'faqOptions' },
//         { value: 'no', label: 'Talk to Human 💬', trigger: 'whatsapp' }
//       ]
//     },
  
//     {
//       id: 'whatsapp',
//       component: (
//         <a
//           href="https://wa.me/9096324272?text=Hi%20Triokzz%20I%20need%20support"
//           target="_blank"
//           rel="noopener noreferrer"
//           style={{
//             background: "#25D366",
//             color: "white",
//             padding: "10px 16px",
//             borderRadius: "8px",
//             display: "inline-block",
//             marginTop: "10px",
//             textDecoration: "none",
//             fontWeight: "bold"
//           }}
//         >
//           Chat on WhatsApp 💬
//         </a>
//       ),
//       end: true
//     }
  
//   ];

const Chatbot = ({steps}) => {
    return (
        <div className="mt-2 bg-gray-50 px-4 pt-8 lg:mt-0">

            <Chatbotmessager
                headerTitle="Triokzz Bot  💬"
                key={steps.length}
                speechSynthesis={{ enable: false, lang: 'en' }}
                 recognitionEnable={false}
                steps={steps}
            />

        </div>
    )
}

export default Chatbot;